<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <p>dashboard works!</p>
            </div>
        </div>
    </div>
</div>
